if (!customElements.get('announcement-countdown')) {
  customElements.define('announcement-countdown', class extends HTMLElement {
    connectedCallback() {
      clearTimeout(this._timeout);
      document.removeEventListener('DOMContentLoaded', this._onReady);
      this._hours = this.querySelector('.abc__hours');
      this._minutes = this.querySelector('.abc__minutes');
      this._seconds = this.querySelector('.abc__seconds');
      if (!this._hours || !this._minutes || !this._seconds) {
        // A previously registered element can connect before the HTML parser
        // has created its children (for example a second section instance).
        if (document.readyState === 'loading') {
          this._onReady = () => this.connectedCallback();
          document.addEventListener('DOMContentLoaded', this._onReady, { once: true });
        }
        return;
      }

      const configuration = JSON.stringify([this.dataset.mode, this.dataset.target, this.dataset.duration]);
      // Keep elapsed time when the editor moves the same node.
      if (this._configuration !== configuration) {
        this._configuration = configuration;
        if (this.dataset.mode === 'duration') {
          this._target = Date.now() + (parseInt(this.dataset.duration, 10) || 0) * 1000;
        } else if (this.dataset.mode === 'daily') {
          this._target = this._nextMidnight();
        } else {
          this._target = new Date(this.dataset.target).getTime();
        }
      }
      if (Number.isFinite(this._target)) this._tick();
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this._onReady);
      clearTimeout(this._timeout);
      this._timeout = null;
    }

    _nextMidnight() {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime();
    }

    _tick() {
      if (!this.isConnected) return;
      let remaining = this._target - Date.now();
      if (remaining <= 0 && this.dataset.mode === 'daily') {
        this._target = this._nextMidnight();
        remaining = this._target - Date.now();
      }
      remaining = Math.max(0, remaining);
      const pad = value => String(Math.floor(value)).padStart(2, '0');
      this._hours.textContent = pad(remaining / 3600000);
      this._minutes.textContent = pad((remaining % 3600000) / 60000);
      this._seconds.textContent = pad((remaining % 60000) / 1000);
      if (remaining > 0) {
        this._timeout = setTimeout(() => this._tick(), 1000 - (Date.now() % 1000));
      }
    }
  });
}
